import { render, staticRenderFns } from "./TimeZone.vue?vue&type=template&id=84c58a2c&"
import script from "./TimeZone.vue?vue&type=script&lang=js&"
export * from "./TimeZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\themes-coder\\rawal\\rawal-laravel11\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84c58a2c')) {
      api.createRecord('84c58a2c', component.options)
    } else {
      api.reload('84c58a2c', component.options)
    }
    module.hot.accept("./TimeZone.vue?vue&type=template&id=84c58a2c&", function () {
      api.rerender('84c58a2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/TimeZone.vue"
export default component.exports